import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import { use } from "react";
import { getPublicPaymentType } from "../../../services/publicService";
import {
  getPlayerSubscription,
  playerPayment,
} from "../../../services/academicService";
import {
  createTenantSubscription,
  getTenantPackage,
} from "../../../services/TenantsService";

const AddTenantPackage = ({ show, onClose, tenant, fetchData }) => {
  const [packageData, setPackageData] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    amountDeposited: "",
    graceDays: "",
  });

  useEffect(() => {
    if (!tenant || paymentMode.length === 0) return;

    const subscription = tenant?.tenantSubcription;

    if (!subscription) return;

    // Find matching package
    const selected = paymentMode.find(
      (item) => item.value === subscription.tenantSubscriptionEnum,
      // Agar API me id use hoti hai to:
      // item.id === subscription.id
    );

    if (selected) {
      setSelectedPaymentMode({
        value: selected.value,
        label: selected.label,
      });

      setFormData((prev) => ({
        ...prev,
        amountDeposited: subscription.amount || "",
        graceDays: subscription.graceDays || "",
      }));
    }
  }, [tenant, paymentMode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!selectedPaymentMode?.value) {
      newErrors.package = "Package is required";
    }

    if (!formData.amountDeposited?.toString().trim()) {
      newErrors.amountDeposited = "Amount deposited is required";
    } else if (Number(formData.amountDeposited) <= 0) {
      newErrors.amountDeposited = "Amount deposited must be greater than 0";
    }

    if (!formData.graceDays?.toString().trim()) {
      newErrors.graceDays = "Grace days is required";
    } else if (Number(formData.graceDays) < 0) {
      newErrors.graceDays = "Grace days cannot be negative";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const payload = {
      tenantId: tenant.id, // or userData?.playerId (use correct key)
      amount: Number(formData.amountDeposited),
      tenantSubscription: selectedPaymentMode?.value,
      graceDays: formData.graceDays,
      // description: formData.description,
    };

    try {
      const res = await createTenantSubscription(payload);
      if (res) {
        onClose();
        toast.success("Package added successfully");
        fetchData();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage || "Failed to save package",
      );
    }
  };

  useEffect(() => {
    fetchPaymentModes();
  }, []);

  async function fetchPaymentModes() {
    try {
      const res = await getTenantPackage();
      setPaymentMode(res);
    } catch (error) {
      console.error("Error fetching package types:", error);
    }
  }

  const resetForm = () => {
    setSelectedPaymentMode(null);
    setSelectedPackage(null);
    setErrors({});
    setFormData({
      amountDeposited: "",
      graceDays: "",
    });
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Package Selection</Modal.Title>
      </Modal.Header>

      <Modal.Body size="1">
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label className="form-label">
                Packages Choose <span className="text-danger">*</span>
              </label>
              <Select
                isSearchable={false}
                options={paymentMode?.map((mode) => ({
                  value: mode?.value,
                  label: mode?.label,
                }))}
                placeholder="Select Package"
                className="custom-react-select"
                value={selectedPaymentMode}
                onChange={(value) => {
                  setSelectedPaymentMode(value);
                  setErrors((prev) => ({ ...prev, package: "" }));
                }}
              />
              {errors.package && (
                <small className="text-danger">{errors.package}</small>
              )}
            </div>
          </div>

          {/* Amount Deposited */}
          <div className="col-sm-12">
            <label className="form-label">
              Amount Deposited <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="amountDeposited"
              placeholder="Enter ammount to be deposited"
              className={`form-control ${errors.amountDeposited ? "is-invalid" : ""}`}
              value={formData.amountDeposited}
              onChange={handleChange}
            />
            {errors.amountDeposited && (
              <small className="text-danger">{errors.amountDeposited}</small>
            )}
          </div>

          <div className="col-sm-12">
            <label className="form-label">
              Grace Days <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="graceDays"
              placeholder="Enter Grace Days"
              className={`form-control ${errors.graceDays ? "is-invalid" : ""}`}
              value={formData.graceDays}
              onChange={handleChange}
            />
            {errors.graceDays && (
              <small className="text-danger">{errors.graceDays}</small>
            )}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddTenantPackage;
